import { Table } from "antd";
import CheckIcon from "@/icons/CheckIcon";

const TYPE_LABELS = {
  text: "Строка",
  textarea: "Текст",
  float: "Дробное",
  integer: "Целое",
  select: "Выбор из списка",
  date: "Дата",
  moment: "Момент",
  money: "Деньги",
  checkbox: "Чекбокс",
  file: "Файл",
};

const FieldsTable = ({ fields = [] }) => {
  const columns = [
    {
      title: "Название поля",
      dataIndex: "name",
      key: "name",
      ellipsis: { showTitle: false },
      width: 200,
    },
    {
      title: "Тип",
      dataIndex: "type",
      key: "type",
      width: 200,
      render: (type) => TYPE_LABELS[type] || type,
    },
    {
      title: "Плейсхолдер",
      dataIndex: "placeholder",
      key: "placeholder",
      ellipsis: { showTitle: false },
      width: 300,
    },
    {
      title: "Обязательность",
      dataIndex: "is_required",
      key: "is_required",
      width: 140,
      align: "center",
      render: (value) =>
        value ? (
          <CheckIcon
            style={{
              fontSize: 18,
              color: "#BBBBBB",
              verticalAlign: "middle",
            }}
          />
        ) : null,
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={fields}
      rowKey={(record) => record.uuid}
      pagination={false}
      size="small"
      scroll={{ x: "100%" }}
      expandable={{
        expandedRowRender: (record) => {
          const options = record.options || [];
          return (
            <Table
              key={`inner-${record.uuid}`}
              columns={[
                {
                  title: "Опции выбора",
                  dataIndex: "value",
                  key: "value",
                },
              ]}
              dataSource={options.map((opt, i) => ({
                ...opt,
                _key: opt.uuid || `opt-${i}`,
              }))}
              rowKey={(item) => item.uuid}
              pagination={false}
              size="small"
            />
          );
        },
        rowExpandable: (record) =>
          record.type === "select" && record.options?.length > 0,
      }}
    />
  );
};

export default FieldsTable;
